const HeroVideo = {
	el: {
		heroVideo: document.querySelector<HTMLVideoElement>(".hero__video video"),
	},
	isMobile: window.innerWidth < 768,
	device: "",

	getDevice: () => {
		if (window.innerWidth <= 575) {
			return "mobile";
		}
		if (window.innerWidth <= 995) {
			return "tablet";
		}
		return "desktop";
	},

	init: () => {
		HeroVideo.device = HeroVideo.getDevice();

		if (HeroVideo.el.heroVideo) {
			window.addEventListener("resize", HeroVideo.resize);
		}
	},
	resize: () => {
		const newIsMobile = HeroVideo.getDevice();

		if (HeroVideo.device !== newIsMobile) {
			HeroVideo.el.heroVideo.load();

			setTimeout(() => {
				HeroVideo.el.heroVideo.play();
			}, 0);
			HeroVideo.device = newIsMobile;
		}
	},
};

export default HeroVideo;
